<template>
  <div class="liff-reservation-service">
    <div v-if="fetching" class="wizard-mode-layout__loading-overlay">
      <div class="wizard-mode-layout__loading-spinner"></div>
      <div class="wizard-mode-layout__loading-text">載入中...</div>
    </div>
    <div v-else>
      <h4 class="text-center my-2" v-if="selectedBranch || selectedStaffForDisplay">{{ selectedBranch.name }} {{ selectedStaffForDisplay }}</h4>
      <div v-if="categories.length > 1">
        <!-- 先關掉有分類的版本 -->
        <div class="liff-reservation-service__category-list">
          <div v-for="category in categories" :key="category.id" :class="`liff-reservation-service__category${openCategories[category.id]?'__active':''}`" @click="scrollToService(category.id)">{{ category.type }}</div>
        </div>
        <div class="liff-reservation-service__item mt-2" :class="{ 'need-bottom': chosenServices.length > 0 }">
          <b-card v-for="category in categories" :key="category.id"
            class="wizard-mode-layout__card"
            :class="{ 'opened': openCategories[category.id] }"
            :ref="category.id"
          >
            <div class="service-group-header" @click="toggle(category.id)">
              <div>{{ category.type }}</div>
              <BIconChevronDown :height="15" class="service-group-header__expand-icon" />
            </div>

            <div class="liff-reservation-service__content" v-if="openCategories[category.id]">
              <div v-for="service in category.items" :key="service.id">
                <input type="checkbox" :id="service.id" class="liff-reservation-service__checkbox" :value="service.id" v-model="chosenServices" @change="handleServiceIsSelected">
                <label :for="service.id" class="liff-reservation-service__content-item" :class="{ 'active': chosenServices.includes(service.id) }">
                  <img v-if="service.image" class="liff-reservation-service__content-item-img" :src="service.image" alt="">
                  <div class="liff-reservation-service__content-item-info">
                    <div class="s-flex s-flex-col s-gap-2">
                      <div v-if="service.title">{{ service.title }}</div>
                      <div class="s-text-secondary s-text-sm" v-if="service.description">{{ service.description }}</div>
                    </div>
                    <div class="s-text-primary" v-if="service.price">{{ service.price }}</div>
                  </div>
                  <BIconCheckCircleFill v-if="chosenServices.includes(service.id)" :height="20" class="s-text-primary liff-reservation-service__content-item-check" />
                </label>
              </div>
            </div>
          </b-card>
        </div>
      </div>
      <div v-else>
        <!-- 沒有分類的 -->
        <div class="liff-reservation-service__item" :class="{ 'need-bottom': chosenServices.length > 0 }">
          <b-card v-for="service in availableServices" class="wizard-mode-layout__card" :key="service.id">
            <input type="checkbox" :id="service.id" class="liff-reservation-service__checkbox" :value="service.id" v-model="chosenServices" @change="handleServiceIsSelected">
            <label :for="service.id" class="liff-reservation-service__content-item" :class="{ 'active': chosenServices.includes(service.id) }">
              <img v-if="service.image" class="liff-reservation-service__content-item-img" :src="service.image" alt="">
              <div class="liff-reservation-service__content-item-info">
                <div class="s-flex s-flex-col s-gap-2">
                  <div v-if="service.title">{{ service.title }}</div>
                  <div class="s-text-secondary s-text-sm" v-if="service.description">{{ service.description }}</div>
                </div>
                <div class="s-text-primary" v-if="service.price">{{ service.price }}</div>
              </div>
              <BIconCheckCircleFill v-if="chosenServices.includes(service.id)" :height="20" class="s-text-primary liff-reservation-service__content-item-check" />
            </label>
          </b-card>
        </div>
      </div>
    </div>

    <div v-if="availableServices.length === 0 && !fetching">
      此分店無可選用的服務，請回上一頁重新選擇
    </div>
    <div class="wizard-mode-layout__footer-navigation">
      <div class="s-flex s-justify-between s-items-center s-mb-3">
        <div class="s-font-medium">已選 {{ chosenServices.length }} 項：<span class="s-text-primary">{{ chosenServicesText }}</span></div>
        <div class="s-text-primary cursor-pointer s-font-medium s-flex-shrink-0" @click="handleCleanServicesIsClicked">重選</div>
      </div>
      <div class="wizard-mode-layout__footer-button-wrapper">
        <button
          class="s-btn s-liff-theme-btn-outline s-btn-sm"
          type="button"
          @click="handleNegativeButtonClicked"
          v-if="hasPreviousStep()"
        >
          上一步
        </button>
        <button
          class="s-btn s-liff-theme-btn s-btn-sm"
          type="button"
          :disabled="chosenServices.length == 0"
          @click="handlePositiveButtonClicked"
        >
          {{ textForProceedButton() }}
        </button>
      </div>
    </div>

    <Popup ref="popup" title="預約注意事項" panelHeight="auto">
      <div class="s-px-3 s-mb-6">
        <ul class="s-list-decimal text-left" style="padding-left: 12px;">
          <li>預約時間為今日起30天內</li>
          <li>如欲取消預約或更改時間可至確認郵件中點選取消連結或撥打專線由專人為您服務，使用上有任何問題歡迎撥打客服專線。<br/>客服電話： (02) 2222-2222</li>
        </ul>
      </div>
      <div slot="actions">
        <button
          class="s-btn s-liff-theme-btn s-btn-sm"
          type="button"
          @click="closePopup"
        >
          知道了
        </button>
      </div>
    </Popup>
  </div>
</template>

<script>
  import { BIconChevronDown, BIconCheckCircleFill } from 'bootstrap-vue'
  import Popup from '@/components/Page/Liff/Shared/Popup.vue';
  import BookingPreset from '@/models/BookingPreset.model'
  import _ from 'lodash'
  import { v4 as uuidv4 } from 'uuid'
  import { mapActions, mapState } from 'vuex'

  export default {
    components: {
      BIconChevronDown,
      BIconCheckCircleFill,
      Popup
    },
    inject: ['back', 'proceed', 'hasPreviousStep', 'textForProceedButton'],
    data() {
      return {
        chosenServices: [],
        openCategories: {},
        fetching: false,
        previousRouteName: null,
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.previousRouteName = from.name
      })
    },
    computed: {
      ...mapState('liffBookingWizard', ['bookingPreset', 'availableServices', 'selectedBranch', 'selectedStaff']),
      chosenServicesText() {
        return this.availableServices
          .filter((service) => this.chosenServices.includes(service.id))
          .map(service => service.title)
          .join('、');
      },
      branchId() {
        return this.$route.query.branch_id
      },
      staffId() {
        return this.$route.query.staff_id
      },
      dataModel() {
        return new BookingPreset(this.bookingPreset)
      },
      categories() {
        const groupedData = this.availableServices.reduce((result, item) => {
          const itemType = item.type || '未分類'
          const existingGroup = result.find(group => group.type === itemType)

          if (existingGroup) {
            existingGroup.items.push(item);
          } else {
            result.push({
              id: uuidv4(),
              type: itemType,
              items: [item]
            });
          }

          return result;
        }, []);
        return groupedData;
      },
      selectedStaffForDisplay() {
        if (this.dataModel.wizardFieldOrder.staff < this.dataModel.wizardFieldOrder.service) {
          return this.selectedStaff.name
        } else {
          return null
        }
      },
    },
    async mounted() {
      this.fetching = true
      await this.init();
      // this.$refs.popup.open();
      this.fetching = false
    },
    methods: {
      ...mapActions('liffBookingWizard', ['fetchBookingPreset', 'fetchServices', 'selectService']),
      handleServiceIsSelected() {
        let serviceIds = Array.isArray(this.chosenServices) ? this.chosenServices : [this.chosenServices]
        serviceIds = serviceIds.filter((id) => this.availableServices.some((service) => service.id == id))
        if (false === this.dataModel.canSelectMultipleServices) {
          serviceIds = serviceIds.length > 0 ? [_.last(serviceIds)] : []
        }
        this.chosenServices = serviceIds
        this.selectService(this.chosenServices)
      },
      handleCleanServicesIsClicked() {
        this.chosenServices = []
        this.selectService(this.chosenServices)
      },
      formatTime(minutes) {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;

        let result = '';
        if (hours > 0) {
          result += `${hours}小時`;
        }
        if (remainingMinutes > 0) {
          result += `${remainingMinutes}分鐘`;
        }

        return result || '0分鐘';
      },
      async init() {
        await this.fetchBookingPreset({ bookingPresetId: this.$route.params.bookingPresetId, branchId: this.branchId })

        await this.fetchServices({ bookingPreset: this.bookingPreset, branchId: this.$route.query.branch_id, staffId: this.$route.query.staff_id })
        if (this.$route.query.service_id) {
          this.chosenServices = this.$route.query.service_id
        }
        this.handleServiceIsSelected()

        let categories = this.categories.filter((cat) => {
            return cat.items.some((item) => this.chosenServices.includes(item.id))
          })

        if (categories) {
            this.openCategories = categories.reduce((acc, category) => {
              acc[category.id] = true; // Set the initial state to true for each category
              return acc;
            }, {});
          }

        if (this.dataModel.shouldAutoSelectTheOnlyService && this.availableServices.length === 1) {
          this.chosenServices = [this.availableServices[0].id]

          const currentStep = this.dataModel.wizardSteps.find(step => step.name === 'LiffReservationService')
          const fromStep = this.dataModel.wizardSteps.find(step => step.name === this.previousRouteName)
          const isComingFromLaterStep = fromStep && fromStep.order > currentStep.order

          if (isComingFromLaterStep) {
            await this.back()
          } else {
            await this.proceed()
          }
        }
      },
      toggle(card) {
        this.$set(this.openCategories, card, !this.openCategories[card]);
      },
      scrollToService(id) {
        this.toggle(id);

        this.$nextTick(() => {
          const element = this.$refs[id][0];
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      },
      handleNegativeButtonClicked() {
        this.back()
      },
      handlePositiveButtonClicked() {
        this.proceed()
      },
      closePopup () {
        this.$refs.popup.close();
      }
    }
  }
</script>

<style lang="scss" scoped>
.liff-reservation-service {
  padding-bottom: 120px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__category-list {
    display: flex;
    flex-wrap: nowrap;
    gap: 4px;
    overflow-x: auto;
  }

  &__category {
    border: 1px solid rgba(99, 99, 102, 0.6);
    border-radius: 50px;
    padding: 7px 16px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    flex-shrink: 0;

    &__active {
      border: 1px solid rgba(99, 99, 102, 0.6);
    border-radius: 50px;
    padding: 7px 16px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    flex-shrink: 0;
      background-color: var(--s-primary);
      border-color: var(--s-primary);
      color: #fff;
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    gap: 12px;

    &.need-bottom {
      margin-bottom: 150px;
    }
  }

  .service-group-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    margin: -16px; // make clickable area larger
    padding: 16px;
    cursor: pointer;

    &__expand-icon {
      transition: transform 0.3s ease-in-out;
    }
  }

  .opened .service-group-header__expand-icon {
    transform: rotate(180deg);
  }

  &__checkbox {
    display: none;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 16px;

    &-item {
      display: flex;
      align-items: center;
      border: 1px solid #E5E5EA;
      border-radius: 10px;
      padding: 12px;
      color: #2C2C2E;
      font-size: 18px;
      font-weight: 500;
      gap: 12px;
      cursor: pointer;
      position: relative;
      &:hover {
        background-color: #F5F5F5;
      }
      &.active {
        border: 2px solid var(--s-primary);
      }
      &-img {
        width: 80px;
        height: 80px;
        border-radius: 50px;
      }
      &-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 12px;
      }
      &-check {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 32px;
        height: 32px;
        padding: 4px;
      }
    }
  }
}
</style>
